import type { Translations } from './de'

const nl: Translations = {
  'language.flag': '🇳🇱',
  'language.name': 'Nederlands',
  'navigation.home': 'Home',
  'navigation.language': 'Taal',
  'navigation.openMenu': 'Menu openen',
  'navigation.closeMenu': 'Menu sluiten',
  'navigation.skipToContent': 'Naar de inhoud',
  'categories.sightseeing.name': 'Bezienswaardigheden',
  'categories.sightseeing.heading': 'De populairste bezienswaardigheden in Augsburg',
  'categories.sightseeing.lead': 'Van UNESCO-werelderfgoed tot de Fuggerei, Augsburg heeft meer te bieden dan je denkt.',
  'categories.events.name': 'Evenementen',
  'categories.events.heading': 'Alle evenementen in één oogopslag',
  'categories.events.lead': 'Concerten, markten, stadsrondleidingen: ontdek wat er deze week in Augsburg te doen is.',
  'categories.blog.name': 'Nieuws',
  'categories.blog.heading': 'Nieuws uit Augsburg',
  'categories.blog.lead': 'Achtergronden, stadsgeschiedenis en actuele onderwerpen om te lezen en door te vertellen.',
  'categories.emptyTitle': 'Nog niets te zien',
  'categories.emptyDescription': 'Er zijn nog geen pagina’s in deze rubriek. Kom binnenkort terug.',
  'home.title': 'Welkom in Augsburg',
  'home.intro': 'Of het nu een stedentrip, zakenreis of familiebezoek is, hier vind je alle belangrijke informatie voor je tijd in Augsburg.',
  'home.sightseeing.eyebrow': 'UNESCO-werelderfgoedstad',
  'home.sightseeing.title': 'Bezienswaardigheden ontdekken',
  'home.sightseeing.lead': 'Van UNESCO-werelderfgoed tot de Fuggerei, Augsburg heeft meer te bieden dan je denkt.',
  'home.sightseeing.action': 'Nu ontdekken',
  'home.events.eyebrow': 'Wat is er te doen in Augsburg?',
  'home.events.title': 'Evenementen vinden',
  'home.events.lead': 'Mis nooit meer een concert, rommelmarkt of festival. Op onze evenementenpagina ben je altijd op de hoogte.',
  'home.events.action': 'Alle evenementen',
  'home.blog.eyebrow': 'Verhalen uit de stad',
  'home.blog.title': 'Nieuws en wetenswaardigheden',
  'home.blog.lead': 'Hier vind je alles wat belangrijk is over Augsburg, zodat je tijdens je bezoek goed geïnformeerd bent.',
  'home.blog.action': 'Naar de blog',
  'home.language.eyebrow': 'Augsburg is internationaal',
  'home.language.title': 'Wissel naar jouw taal',
  'home.language.lead': 'Deze website is in meerdere talen beschikbaar. Wil je van taal wisselen?',
  'home.highlights.eyebrow': 'Voor jou samengesteld',
  'home.highlights.title': 'Onze aanraders',
  'home.highlights.lead': 'Voor een goede start hebben we enkele hoogtepunten in Augsburg voor je verzameld. Veel leesplezier!',
  'search.placeholder': 'Zoeken...',
  'search.clear': 'Zoekopdracht wissen',
  'search.label': "Pagina's doorzoeken",
  'search.results': '{{count}} resultaten voor „{{query}}”',
  'search.emptyTitle': 'Geen resultaten',
  'search.emptyDescription': 'We hebben niets gevonden voor deze zoekopdracht. Probeer een ander woord.',
  'pagination.label': 'Pagina’s',
  'pagination.previous': 'Vorige pagina',
  'pagination.next': 'Volgende pagina',
  'pagination.page': 'Pagina {{page}}',
  'pagination.summary': '{{start}}–{{end}} van {{total}}',
  'page.back': 'Terug',
  'page.readMore': 'Meer lezen',
  'page.tableOfContents': 'Op deze pagina',
  'page.openInGoogleMaps': 'Openen in Google Maps',
  'map.copyAddress': 'Adres kopiëren',
  'map.copied': 'Gekopieerd',
  'map.copyFailed': 'Kopiëren niet mogelijk',
  'map.routeInGoogleMaps': 'Route in Google Maps',
  'map.zoomIn': 'Inzoomen',
  'map.zoomOut': 'Uitzoomen',
  'map.showAll': 'Alles tonen',
  'attribution.toggle': 'Bronvermelding tonen of verbergen',
  'map.gestures.windows': 'Gebruik Ctrl + scrollen om in te zoomen',
  'map.gestures.mac': 'Gebruik ⌘ + scrollen om in te zoomen',
  'map.gestures.mobile': 'Verplaats de kaart met twee vingers',
  'map.loading': 'Kaart wordt geladen …',
  'map.failed': 'De kaart kon niet worden geladen.',
  'map.showPlace': '{{name}} op de kaart tonen',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'ca. {{duration}} lopen',
  'map.route.stops': '{{count}} haltes',
  'map.route.leg': '{{distance}} · ca. {{duration}}',
  'mapIcons.landmark': 'Bezienswaardigheid',
  'mapIcons.church': 'Kerk',
  'mapIcons.museum': 'Museum',
  'mapIcons.park': 'Park & natuur',
  'mapIcons.viewpoint': 'Uitzichtpunt',
  'mapIcons.cafe': 'Café',
  'mapIcons.bar': 'Bar',
  'mapIcons.restaurant': 'Restaurant',
  'mapIcons.shop': 'Winkelen',
  'mapIcons.event': 'Evenementenlocatie',
  'mapIcons.transport': 'Vervoer',
  'mapIcons.place': 'Plek',
  'footer.imprint': 'Colofon',
  'footer.privacy': 'Privacyverklaring',
  'footer.mediaLicense': 'Beeldrechten',
  'legal.bindingNote': 'Deze vertaling is uitsluitend ter informatie. Alleen de Duitse versie is juridisch bindend.',
  'imprint.provider.heading': 'Gegevens volgens § 5 DDG',
  'imprint.contact.heading': 'Contact',
  'imprint.contact.email': 'E-mail',
  'imprint.responsible.heading': 'Verantwoordelijk voor de inhoud volgens § 18 lid 2 MStV',
  'privacy.intro': 'In deze privacyverklaring leggen we uit welke persoonsgegevens worden verwerkt wanneer je deze website bezoekt.',
  'privacy.controller.heading': 'Verwerkingsverantwoordelijke',
  'privacy.controller.text': 'Verantwoordelijk voor de gegevensverwerking op deze website is:',
  'privacy.hosting.heading': 'Hosting',
  'privacy.hosting.text': 'Deze website wordt gehost door een externe hostingprovider met vestiging in Duitsland. De servers staan in Duitsland.',
  'privacy.serverLogs.heading': 'Serverlogbestanden',
  'privacy.serverLogs.text': 'Bij elk bezoek aan deze website slaat de server automatisch informatie op die je browser doorgeeft: IP-adres, datum en tijd van het verzoek, opgevraagde pagina, overgedragen hoeveelheid data, referrer-URL en browser en besturingssysteem. Deze gegevens zijn nodig om de website veilig en stabiel te laten werken (art. 6 lid 1 sub f AVG) en worden uiterlijk na 7 dagen verwijderd.',
  'privacy.analytics.heading': 'Bereikmeting',
  'privacy.analytics.text': 'Om te weten welke pagina’s gelezen worden, tellen we paginaweergaven zelf, zonder externe diensten en zonder cookies. Wanneer je een pagina opent, meldt je browser alleen het adres ervan aan onze server. Per adres, taal en dag slaan we uitsluitend het aantal weergaven op, gescheiden naar browsers en geautomatiseerde programma’s (crawlers), die we onderscheiden aan de hand van de browseridentificatie (user agent). Je IP-adres, browseridentificatie of andere gegevens over jou worden hiervoor niet opgeslagen; herleiding tot individuele bezoekers is niet mogelijk. Als je browser het signaal „Global Privacy Control” of „Do Not Track” verstuurt, wordt je bezoek niet geteld. De cijfers worden na een jaar verwijderd. De rechtsgrond is art. 6 lid 1 sub f AVG; ons gerechtvaardigd belang is het verbeteren van deze website.',
  'privacy.errorReports.heading': 'Foutmeldingen',
  'privacy.errorReports.text': 'Als er bij het laden van een pagina een technische fout optreedt, wordt automatisch een e-mail met informatie over het mislukte verzoek naar de beheerder gestuurd. Deze kan je IP-adres, het opgevraagde adres en gegevens over je browser bevatten. Foutmeldingen worden uitsluitend gebruikt om fouten te verhelpen (art. 6 lid 1 sub f AVG).',
  'privacy.cookies.heading': 'Cookies',
  'privacy.cookies.text': 'Deze website gebruikt uitsluitend technisch noodzakelijke cookies, die nodig zijn voor je sessie en ter bescherming tegen vervalste verzoeken (CSRF). Ze bevatten geen gegevens voor analyse of reclame en worden verwijderd wanneer je je browser sluit. De rechtsgrond is § 25 lid 2 nr. 2 TDDDG in samenhang met art. 6 lid 1 sub f AVG; toestemming is niet vereist. Er worden geen externe analyse- of trackingdiensten gebruikt; de hierboven beschreven bereikmeting werkt zonder cookies.',
  'privacy.rights.heading': 'Jouw rechten',
  'privacy.rights.text': 'Je hebt recht op:',
  'privacy.rights.access': 'inzage in je opgeslagen gegevens (art. 15 AVG)',
  'privacy.rights.rectification': 'rectificatie (art. 16 AVG)',
  'privacy.rights.erasure': 'wissing (art. 17 AVG)',
  'privacy.rights.restriction': 'beperking van de verwerking (art. 18 AVG)',
  'privacy.rights.portability': 'overdraagbaarheid van gegevens (art. 20 AVG)',
  'privacy.rights.objection': 'bezwaar tegen de verwerking (art. 21 AVG)',
  'privacy.rights.contact': 'Om deze rechten uit te oefenen, stuur je gewoon een e-mail naar:',
  'privacy.complaint.heading': 'Recht om een klacht in te dienen',
  'privacy.complaint.text': 'Je hebt het recht om een klacht in te dienen bij een toezichthoudende autoriteit voor gegevensbescherming. Bevoegd is het Beierse Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Duitsland.',
  'privacy.updated': 'Laatst bijgewerkt: oktober 2026',
  'mediaLicense.intro': 'Alle foto’s, video’s, documenten en routes op deze website zijn eigendom van Visit Augsburg. Je mag ze gebruiken, delen en bewerken onder de licentie Creative Commons Naamsvermelding 4.0 Internationaal (CC BY 4.0) – ook commercieel – zolang je ons als bron vermeldt.',
  'mediaLicense.credit.heading': 'Zo vermeld je ons als bron',
  'mediaLicense.credit.text': 'Toon deze vermelding goed zichtbaar direct bij de foto of video:',
  'mediaLicense.credit.link': 'Link waar mogelijk naar de pagina waar het medium vandaan komt en naar de licentie. Als je een medium hebt bewerkt, vermeld dat dan.',
  'mediaLicense.ai.heading': 'AI-assistenten en zoekmachines',
  'mediaLicense.ai.text': 'Dit geldt ook voor chatbots, AI-assistenten en zoekmachines: wie een foto of video van deze website toont, toont daarbij de vermelding ‘{{credit}}’. Maker, vermelding en licentie staan machineleesbaar in elk afbeeldingsbestand (IPTC/XMP) en in de gestructureerde gegevens (schema.org) van elke pagina.',
  'mediaLicense.license.heading': 'Licentie',
  'mediaLicense.license.text': 'De licentietekst van Creative Commons is van toepassing:',
  'mediaLicense.license.link': 'CC BY 4.0 – Naamsvermelding 4.0 Internationaal',
  'mediaLicense.scope.heading': 'Wat niet onder de licentie valt',
  'mediaLicense.scope.text': 'De teksten van deze website maken geen deel uit van de licentie. De kaartgegevens zijn afkomstig van OpenStreetMap en vallen onder de Open Database License (© OpenStreetMap-bijdragers).',
  'mediaLicense.contact': 'Vragen over het gebruik? Stuur een e-mail naar:',
  'mediaLicense.updated': 'Laatst bijgewerkt: oktober 2026',
  'gallery.previous': 'Vorige afbeelding',
  'gallery.next': 'Volgende afbeelding',
  'gallery.showImage': '{{title}} weergeven',
  'video.play': '{{title}} afspelen',
  'videoGallery.summaryOne': '1 video · {{minutes}} min.',
  'videoGallery.summaryOther': '{{count}} video’s · {{minutes}} min.',
  'tags.unesco_heritage': 'UNESCO-werelderfgoed',
  'tags.landmark': 'Bezienswaardigheid',
  'tags.church_monastery': 'Kerk & klooster',
  'tags.museum_culture': 'Museum & cultuur',
  'tags.park_nature': 'Park & natuur',
  'tags.viewpoint': 'Uitzichtpunt',
  'tags.accessible': 'Toegankelijk',
  'tags.free': 'Gratis',
  'tags.family_friendly': 'Voor gezinnen',
  'tags.concert': 'Concert',
  'tags.market': 'Markt',
  'tags.guided_tour': 'Rondleiding',
  'tags.festival': 'Festival',
  'tags.exhibition': 'Tentoonstelling',
  'tags.sports': 'Sport',
  'tags.open_air': 'Openlucht',
  'tags.city_history': 'Stadsgeschiedenis',
  'tags.tips_tricks': 'Tips & trucs',
  'tags.interview': 'Interview',
  'tags.food_drink': 'Eten & drinken',
  'tags.seasonal': 'Seizoensgebonden',
  'tags.behind_the_scenes': 'Achter de schermen',
  'tags.event_recap': 'Terugblik op evenement',
}

export default nl
